<template>
  <v-container class="container-card">
    <v-card>
      <TabelaRegioes />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaRegiao",

  components: {
    TabelaRegioes: () => import("@/components/empresa/regioes/TabelaRegioes")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Região");
  }
};
</script>
